export default class xt {
  constructor(t) {
    this.Bl = t;
  }
  Gl(t) {
    return null == this.Bl || this.Bl === t[0];
  }
  static fromJson(t) {
    return new xt(t ? t.event_name : null);
  }
  ss() {
    return this.Bl;
  }
}
